import { render, staticRenderFns } from "./TaskLink.vue?vue&type=template&id=024296c8"
import script from "./TaskLink.vue?vue&type=script&lang=js"
export * from "./TaskLink.vue?vue&type=script&lang=js"
import style0 from "./TaskLink.vue?vue&type=style&index=0&id=024296c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports